import {
  ReportingCategory,
  StoreSite,
  XenialCatalogEntry,
  XenialCatalogResponse,
  PaginatedXenialCatalogs,
} from '@generated/tcea/models';
import { Observable, Subject } from 'rxjs';

export interface XenialSyncStatusResult {
  status: string | null;
  lastSyncTime: string | null;
  isLoading: boolean;
}

export abstract class AbstractXenialService {
  abstract getReportingCategories(
    brandId: string,
    xenialBrandId: string,
  ): Observable<ReportingCategory[]>;

  abstract getXenialDetails(
    brandId: string,
    catalogEntryId: string,
  ): Observable<XenialCatalogResponse>;

  abstract save(catalogEntryId: string, brandId: string, body: XenialCatalogEntry): Observable<any>;

  abstract getXenialStores(companyId: string, brandId?: string): Observable<StoreSite[]>;

  abstract getXenialCatalogs(brandId: string): Observable<PaginatedXenialCatalogs>;

  abstract loadXenialSyncStatus(
    brandId: string,
    catalogEntryId: string,
    unsubscribe$: Subject<void>,
  ): Observable<XenialSyncStatusResult>;

  abstract getXenialSyncStatusIcon(status: string | null, isLoading: boolean): string;

  abstract getXenialSyncStatusIconClass(status: string | null, isLoading: boolean): string;

  abstract getXenialSyncStatusClass(status: string | null): string;

  abstract getXenialSyncStatusText(status: string | null, isLoading: boolean): string;

  abstract getXenialSyncTooltip(
    status: string | null,
    lastSyncTime: string | null,
    isLoading: boolean,
  ): string;
}
